import _URL from '../../URL/index';
const axios = _URL.axios;

export default {
    services: {
        createSurcharge: (surcharge, token = "") => {
            return axios(token).post(`/surcharges`, surcharge);
        },
        getSurchargeById: (surchargeId, token = "") => {
            return axios(token).get(`/surcharges/${surchargeId}`);
        },
        updateSurchargeById: (surchargeId, surcharge, token = "") => {
            return axios(token).put(`/surcharges/${surchargeId}`, surcharge);
        },
        deleteSurchargeById: (surchargeId, token = "") => {
            return axios(token).delete(`/surcharges/${surchargeId}`)
        },
        updateAnyAttributeById: (surchargeId, payload, token = "") => {
            return axios(token).patch(`/surcharges/${surchargeId}`, payload);
        }
    }
}
